import api from '@/services/api'
const url = action => `/insurancedata${action}`

export async function postFindByCondition(page, params){
    const { data: res } = await api.post(url('/findByCondition?page=' + page),params)
    return res
}

export async function postNew(params){
    const { data: res } = await api.post(url('/'),params)
    return res
}

export async function getById(id, params){
    const { data: res } = await api.get(url('/' + id),params)
    return res
}

export async function putById(id, params){
    const { data: res } = await api.put(url('/' + id),params)
    return res
}


export async function deleteById(id){
    const { data: res } = await api.delete(url('/' + id))
    return res
}